export default {
    namespaced: true,
    state() {
        return {
            settings: [],
            plugins: [],
            permissions: {},
        };
    },
    getters: {
        getSettings: (state) => state.settings,
        getPlugins: (state) => state.plugins,
        getPermissions: (state) => state.permissions,
        getInternalPlugins: (state) => state.plugins.filter((plugin) => !plugin.external),
        getExternalPlugins: (state) => state.plugins.filter((plugin) => plugin.external),
    },
    mutations: {
        setSettings(state, settings) {
            state.settings = settings;
        },
        setPlugins(state, plugins) {
            state.plugins = plugins;
        },
        setPermissions(state, permissions) {
            state.permissions = permissions;
        },
    },
    actions: {
        fetchMenu({ commit }) {
            return new Promise((resolve, reject) => {
                SellsyJS.WebServiceCaller.post(
                    '/?_f=listingPreferences&action=getSettings',
                    {},
                    {},
                    function (data) {
                        commit('setSettings', data.settings);
                        commit('setPlugins', data.plugins);
                        commit('setPermissions', data.permissions);
                        resolve();
                    },
                    function (err) {
                        reject(err);
                    },
                );
            });
        },
    },
};
